export const DataWithServicesColumns = [
    {
        name: 'Заказ/Накладная',
        key: 'info',
    },
    {
        name: 'Забор/Доставка',
        key: 'type',
    },
    {
        name: 'Направление',
        key: 'from',
    },
    {
        name: 'Дата создания',
        key: 'created_at',
    },
    {
        name: 'Клиент',
        key: 'company_name',
    },
    {
        name: 'Статус',
        key: 'status_name',
    },
    {
        name: 'Доп. услуги',
        key: 'additional_service',
    },
    {
        name: 'Кубатура',
        key: 'cubature',
    },
]
